import React from "react";
import { Link } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, logOut } from "../firebase";
import { Button, Dropdown } from "react-bootstrap";
import "./Header.css";

const Header = ({ toggleSidebar }) => {
  const [user] = useAuthState(auth);

  const handleLogout = async () => {
    try {
      await logOut();
      console.log("User logged out successfully");
    } catch (error) {
      console.error("Logout failed: ", error);
    }
  };

  return (
    <header className="header">
      <div className="header-content">
        <nav className="main-nav">
          <Link to="/" className="logo">
            <div className="logo-container">
              <img src="/assets/logo.svg" alt="Fairpatterns Logo" className="logo-image" />
            </div>
          </Link>
          <Link to="/">Explore</Link>
          <Link to="/dashboard">Dashboard</Link>
          <Link to="/demo">Demo</Link>
          <Link to="/updates">Updates</Link>
          <a href="#contact">Contact Us</a>

          {/* User Authentication Section */}
          {user && (
            <div className="user-section d-flex align-items-center ms-3">
              <Dropdown align="end">
                <Dropdown.Toggle
                  variant="outline-light"
                  id="user-dropdown"
                  className="d-flex align-items-center border-0"
                >
                  <span className="user-name d-none d-md-inline">
                    {user.displayName || user.email}
                  </span>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.ItemText>
                    <div>
                      <strong>{user.displayName}</strong>
                      <br />
                      <small className="text-muted">{user.email}</small>
                    </div>
                  </Dropdown.ItemText>
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={handleLogout}>
                    <i className="fas fa-sign-out-alt me-2"></i>
                    Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}

          <button className="hamburger-button" onClick={toggleSidebar}>
            <img src="/assets/silder_image.png" alt="Menu" className="hamburger-icon" />
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
